export enum OrderItemsColumnsEnum {
  variantImg = 1,
  productCode = 2,
  productTitle = 3,
  gender = 4,
  styleGroup = 5,
  colorCode = 6,
  colorName = 7,
  sizeGroup = 8,
  sizeName = 9,
  ean = 10,
  sku = 11,
  date = 12,
  qty = 13,
  note = 14,
  unitWholesale = 15,
  unitRetail = 16,
  discountedUnitPrice = 17,
  unitCost = 18,
  unitMargin = 19,
  totalRetail = 20,
  totalWholesale = 21,
  discountedTotalPrice = 22,
  totalCost = 23,
  totalMargin = 24,
  discountFromRetail = 25,
  discountFromWholesale = 26,
  customerDiscountPerc = 27,
  agreementDiscountPerc = 28,
  financialDiscountPerc = 29,
  storeChannelDiscountPerc = 30,
  discountByQty = 31,
  discountByValue = 32,
  commercialDiscountPerc = 33,
  marginPercent = 34,
  orderedQty = 35,
  notFulfilledQty = 36,
  canceledQty = 37,
  deliveredQty = 38,
  fulfillmentStatus = 39,
  CancellationReason = 40
}
